function page(path) {
  return () => import(`@/views/${path}`).then(m => m.default || m);
}

export default [
  {
    path: "/login",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Login",
        meta: {
          layout: "GuestLayout",
          requiresAuth: false
        },
        component: page("Auth/Login.vue")
      }
    ]
  },
  {
    name: "403",
    meta: {
      layout: "ErrorLayout",
      requiresAuth: false
    },
    path: "/403",
    component: page("403.vue")
  },
  {
    path: "/",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Dashboard",
        redirect: "/timesheets",
        meta: {
          layout: "AuthLayout",
          requiresAuth: true
        },
        component: page("TimeSheets/UserTimeSheetList.vue")
      },

      {
        path: "/timesheets",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "TimeSheet",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "timesheet"
            },
            component: page("TimeSheets/UserTimeSheetList.vue")
          },
          {
            path: "logwork",
            name: "Log Work Timeline",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "logWorkTimeline"
            },
            component: page("Logwork/LogWorkTimeline.vue")
          }
        ]
      },
      {
        path: "/additional-timesheet",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/",
            name: "Additional Timesheet",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetList"
            },
            component: page("AdditionalTimesheet/ListAdditionalTimesheet")
          },
          {
            path: "approval",
            name: "Additional Timesheet Approval",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetApprovalList"
            },
            component: page(
              "AdditionalTimesheet/ListAdditionalTimesheetApproval"
            )
          },
          {
            path: "detail/:id",
            name: "Additional Timesheet Detail",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetDetail"
            },
            component: page("AdditionalTimesheet/DetailAdditionalTimesheet")
          },
          {
            path: "create",
            name: "Additional Timesheet Create",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetCreate"
            },
            component: page("AdditionalTimesheet/CreateAdditionalTimesheet")
          },
          {
            path: "update/:id",
            name: "Additional Timesheet Update",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetUpdate"
            },
            component: page("AdditionalTimesheet/UpdateAdditionalTimesheet")
          },
          {
            path: "approval/:id",
            name: "Additional Timesheet Request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "additionalTimesheetApproval"
            },
            component: page("AdditionalTimesheet/ApprovalAdditionalTimesheet")
          }
        ]
      },
      {
        path: "/overtime-requests",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/",
            name: "Overtime Request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeList"
            },
            component: page("OverTimeRequests/ListOverTimeRequest")
          },
          {
            path: "approval",
            name: "Overtime Request Approval",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeApprovalList"
            },
            component: page("OverTimeRequests/ListOverTimeRequestApproval")
          },
          {
            path: "detail/:id",
            name: "Detail Overtime",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeDetail"
            },
            component: page("OverTimeRequests/DetailOverTimeRequest")
          },
          {
            path: "create",
            name: "Employee Overtime Create",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeCreate"
            },
            component: page("OverTimeRequests/CreateEmployeeOverTime")
          },
          {
            path: "update/:id",
            name: "Employee Overtime Update",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeUpdate"
            },
            component: page("OverTimeRequests/UpdateEmployeeOverTime")
          },
          {
            path: "approval/:id",
            name: "Approval Overtime Request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "overtimeListApproval"
            },
            component: page("OverTimeRequests/ApprovalEmployeeOverTime")
          }
        ]
      },
      {
        path: "/logwork",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Logwork Timeline",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Logwork/LogworkTimeline.vue")
          },
          {
            path: "approval",
            name: "Logwork Approval",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Logwork/LogworkApproval.vue")
          }
        ]
      },
      {
        path: "/sabbatical-leave-request",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/",
            name: "Sabbatical leave request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalList"
            },
            component: page("SabbaticalLeaveRequest/SabbaticalRequestList")
          },
          // {
          //   path: "list",
          //   name: "Sabbatical Request List",
          //   meta: {
          //     layout: "AuthLayout",
          //     requiresAuth: true,
          //     breadcrumb: "sabbaticalList"
          //   },
          //   component: page("SabbaticalLeaveRequest/SabbaticalRequestList")
          // },
          // {
          //   path: "approval",
          //   name: "Sabbatical Request Approval",
          //   meta: {
          //     layout: "AuthLayout",
          //     requiresAuth: true,
          //     breadcrumb: "sabbaticalApprovalList"
          //   },
          //   component: page(
          //     "SabbaticalLeaveRequest/SabbaticalLeaveListApproval"
          //   )
          // },
          {
            path: "detail/:id",
            name: "Detail Sabbatical Leave",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalDetail"
            },
            component: page(
              "SabbaticalLeaveRequest/SabbaticalLeaveRequestDetail"
            )
          },
          {
            path: "create",
            name: "Employee Sabbatical Leave Create",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalCreate"
            },
            component: page("SabbaticalLeaveRequest/CreateSabbaticalLeave")
          },
          {
            path: "update/:id",
            name: "Employee Sabbatical Leave Update",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalUpdate"
            },
            component: page("SabbaticalLeaveRequest/UpdateSabbaticalLeave")
          },
          {
            path: "approval/:id",
            name: "Approval Sabbatical Leave Request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalApproval"
            },
            component: page("SabbaticalLeaveRequest/ApprovalSabbaticalLeave")
          },
          {
            path: "statistical",
            name: "Sabbatical Leave Statistical",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "sabbaticalStatistical"
            },
            component: page("SabbaticalLeaveRequest/SabbaticalLeaveStatistical")
          },
          {
            path: "short-leave-request",
            name: "Short leave request",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "shortLeaveRequest"
            },
            component: page("SabbaticalLeaveRequest/ShortLeaveRequestList")
          }
        ]
      },
      {
        path: "/skill-sheet",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Skill Sheet Create",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "skillsheetCreate"
            },
            component: page("SkillSheet/FormSkillSheet")
          }
        ]
      },
      {
        path: "/seating-chart",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Seat Management",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "seat"
            },
            component: page("SeatingChart/ListSeatingChart")
          }
        ]
      },
      {
        path: "/note",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "overtime",
            name: "note overtime",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Note/OverTime.vue")
          },
          {
            path: "timesheet",
            name: "note timesheet",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Note/TimeSheet.vue")
          },
          {
            path: "sabbatical",
            name: "note sabbatical",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Note/Sabbatical.vue")
          },
          {
            path: "document",
            name: "note document",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "note"
            },
            component: page("Note/Document.vue")
          }
        ]
      },
      {
        path: "/information-profile",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "Profile",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "profile"
            },
            component: page("Information/Profile.vue")
          }
        ]
      },
      {
        path: "/add-skill",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "AddSkill",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("Information/AddSkill.vue")
          }
        ]
      },
      {
        path: "/checkpoint",
        component: () => import("@/views/CheckPoint/CheckPointLayout.vue"),
        children: [
          {
            path: "",
            name: "CheckPointOverview",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_create"
            },
            component: page("CheckPoint/CheckPointOverview.vue")
          },
          {
            path: "myself",
            name: "CheckPointMySelf",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_myself"
            },
            component: page("CheckPoint/CheckPointForm.vue")
          },
          {
            path: "result",
            name: "CheckPointResult",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_result_member"
            },
            component: page("CheckPoint/CheckPointResult.vue")
          },
          {
            path: "list-waiting-pm",
            name: "List Waiting PM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_list_pm"
            },
            component: page("CheckPoint/CheckPointWaitingList.vue"),
            params: true
          },
          {
            path: "list-waiting-dm",
            name: "List Waiting DM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_list_dm"
            },
            component: page("CheckPoint/CheckPointWaitingListDM.vue")
          },
          {
            path: "list-waiting-interview",
            name: "List Waiting BOD",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_list_interview"
            },
            component: page("CheckPoint/CheckPointWaitingBOD.vue")
          },
          {
            path: "checkpoint-by-pm",
            name: "Check Point PM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_pm"
            },
            component: page("CheckPoint/CheckPointPM.vue")
          },
          {
            path: "result-check-point-pm",
            name: "Result Check Point PM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_result_pm"
            },
            component: page("CheckPoint/CheckPointResultPM.vue")
          },
          {
            path: "checkpoint-by-dm",
            name: "Check Point DM PM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_dm"
            },
            component: page("CheckPoint/CheckPointDM.vue")
          },
          {
            path: "interview",
            name: "Check Point Interview BOD",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_interview"
            },
            component: page("CheckPoint/CheckPointInterviewBOD.vue")
          },
          {
            path: "result-dm-bod-ihr",
            name: "Result BOD DM",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "checkpoint_result_bod"
            },
            component: page("CheckPoint/CheckPointResultDMBOD.vue")
          },
          {
            path: "see-review",
            name: "Check Point See",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "see_review"
            },
            component: page("CheckPoint/CheckPointSeeReview.vue")
          },
          {
            path: "guide",
            name: "Check Point Guide",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true
            },
            component: page("CheckPoint/CheckPointGuide.vue")
          }
        ]
      },
      {
        path: "/summer-trip",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "vote",
            name: "Summer Trip Vote",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "summerTripVote"
            },
            component: page("SummerTrip/Vote.vue")
          },
          {
            path: "vote-chart",
            name: "Summer Trip Vote Chart",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "summerTripVoteChart"
            },
            component: page("SummerTrip/VoteChart.vue")
          }
        ]
      },
      {
        path: "/redirect",
        name: "RedirectWarning",
        meta: {
          layout: "AuthLayout",
          requiresAuth: true,
          breadcrumb: "redirect"
        },
        component: page("Redirect/RedirectWarning.vue")
      },
      {
        path: "/news",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "/",
            name: "new list",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "newList"
            },
            component: page("News/NewList.vue")
          },
          {
            path: "create",
            name: "New Create",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "newCreate"
            },
            component: page("News/NewCreate.vue")
          },
          {
            path: "edit/:id",
            name: "New Update",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "newUpdate"
            },
            component: page("News/NewUpdate.vue")
          }
        ]
      },
      {
        path: "/project-management",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "ProjectManagement",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementList"
            },
            component: page("ProjectManagement/index")
          },
          {
            path: "logwork-approval",
            name: "Project Management Logwork Approval",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "logworkApproval"
            },
            component: page("Logwork/LogWorkApproval.vue")
          },
          {
            path: "/project-management/:id/effort",
            name: "ProjectEffort",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementEffort"
            },
            component: page("ProjectManagement/Effort.vue")
          },
          {
            path: "/project-management/:id/activities",
            name: "activities",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementActivities"
            },
            component: page(
              "ProjectManagement/KickOffAndBonus/KickOffAndBonusList"
            )
          },
          {
            path: "/project-management/:id/detail",
            name: "ProjectDetail",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementUpdate"
            },
            component: page("ProjectManagement/Detail.vue")
          },
          {
            path: "/project-management/:id/review",
            name: "ProjectReview",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementReview"
            },
            component: page("ProjectManagement/Review.vue")
          },
          {
            path: "/project-management/:id/contract-management",
            name: "ContractManagement",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "projectManagementHistory"
            },
            component: page("ProjectManagement/ContractManagement.vue")
          }
        ]
      },
      {
        path: "/remote-request",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          {
            path: "",
            name: "RemoteRequest",
            meta: {
              layout: "AuthLayout",
              requiresAuth: true,
              breadcrumb: "remoteRequestList"
            },
            component: page("RemoteRequest/ListRemoteRequest")
          }
        ]
      }
    ]
  },
  {
    path: "*",
    name: "Error 404",
    meta: {
      layout: "ErrorLayout",
      requiresAuth: false
    },
    component: page("404.vue")
  }
];
